import {TrademarkInput} from "@/endpoints/rutsolve/gql/generated/types"

export class TrademarkSelector {
    static readonly trademarkInput: string = "TRADEMARK_SELECTOR_TRADEMARK_INPUT"
    static readonly selectedTrademarkID: string = "TRADEMARK_SELECTOR_SELECTED_TRADEMARK_ID"

    private static defaultTrademarkInput: TrademarkInput = {
        order: "UPDATED_AT_DESCENDING",
        plot: {
            items: 10,
            page: 1
        },
    }

    public static readTrademarkInput(): TrademarkInput {
        const trademarkInput = sessionStorage.getItem(this.trademarkInput)
        if (trademarkInput) {
            return JSON.parse(trademarkInput) as TrademarkInput
        }
        return this.defaultTrademarkInput
    }

    public static readSelectedTrademarkID(): string {
        return sessionStorage.getItem(this.selectedTrademarkID)
    }

    public static writeTrademarkInput(input: TrademarkInput) {
        sessionStorage.setItem(this.trademarkInput, JSON.stringify(input))
    }

    public static writeSelectedTrademarkID(input: string) {
        sessionStorage.setItem(this.selectedTrademarkID, input)
    }

    public static deleteTrademarkInput() {
        sessionStorage.removeItem(this.trademarkInput)
    }

    public static deleteSelectedTrademarkID() {
        sessionStorage.removeItem(this.selectedTrademarkID)
    }
}
